export default __webpack_public_path__ + "static/Tripadvisor_CaseStudy_Title-Video-720-694fef360253cbb3ff0e644dd970aaa8.webm";